import { render, staticRenderFns } from "./sales-invoice-reminder-button.vue?vue&type=template&id=28e81628"
import script from "./sales-invoice-reminder-button.vue?vue&type=script&lang=js"
export * from "./sales-invoice-reminder-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports